import script from "./AuTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AuTable.vue?vue&type=script&setup=true&lang=js"

import "./AuTable.vue?vue&type=style&index=0&id=15e6ac08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e6ac08"]])

export default __exports__